document.addEventListener("DOMContentLoaded", function() {
  // Get the current pathname
  var currentPath = window.location.pathname;
  var isFrench = currentPath.startsWith('/fr');
  
  // Check all internal links
  document.querySelectorAll('a[href^="/"]').forEach(function(link) {
    var href = link.getAttribute('href');

    // If user is on the French site and the link doesn't already include '/fr'
    if (isFrench && !href.startsWith('/fr') && !href.startsWith('/en')) {
      // Add '/fr' to the link
      link.setAttribute('href', '/fr' + href);
    }
  });

  // Allow switching back to English or other languages using the dropdown selector
  // Assuming the dropdown adds the correct language prefix to URLs
});